import React from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

const CourseItem = ({ course }) => {
  let history = useHistory();
  const img = `https://stucharge.bakersbrisk.com${course.image}`;
  const bgStyle = {
    backgroundImage: `url("${img}")`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };

  let title = course.title;
  if (title.length > 40) {
    title = title.substring(0, 40) + '...';
  }

  const handleDelete = (key) => {
    const uname = JSON.parse(localStorage.getItem('uname'));
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    const URL = `https://stucharge.bakersbrisk.com/api/courseapi?username=${uname}&id=${key}`;
    var bodyFormData = new FormData();

    Swal.fire({
      title: 'Are you sure? Course will be deleted permanantly',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        updateData();
      } else if (result.isDenied) {
        Swal.fire('Course not deleted', '', 'info');
      }
    });

    async function updateData() {
      bodyFormData.append('status', false);

      const requestOptions = {
        method: 'PUT',
        headers: { Authorization: AuthStr },
        body: bodyFormData,
      };
      fetch(URL, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          Swal.fire('Course deleted successfully!', '', 'success').then(
            (result) => {
              if (result.isConfirmed || !result.isConfirmed) {
                history.push('/home');
                history.push('/courses');
              }
            }
          );
        })
        .catch((error) => {
          Swal.fire('Error deleting course', '', 'error');
        });
    }
  };

  return (
    <div className='division'>
      <div className='card' style={bgStyle}>
        <a href={`/courses/${course.id}`}>
          <i className='fas fa-play-circle'></i>
        </a>
      </div>
      <div className='card_inner'>
        <h3 className='text-title'>{title}</h3>
        <div className='price'>
          <span className='font-bold text-white'>
            {course.price === 0 ? 'Free' : `₹${course.offer_price}`}
          </span>
        </div>
      </div>
      <div className='div-button'>
        <a
          className='bttn update'
          style={{ margin: '15px auto 5px', width: '30%', fontSize: '1.1rem' }}
          href={`/courses/edit/${course.id}`}
        >
          Edit
        </a>
        <button
          onClick={() => handleDelete(course.id)}
          className='bttn delete'
          style={{ margin: '15px auto 5px', width: '30%', fontSize: '1.1rem' }}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default CourseItem;
